export const features = [
  "All In One!",
  "Mobile Event App",
  "Ticketing",
  "Attendee Networking",
  "Badge Printing & Check-In",
  "Agenda Builder",
  "Event Guide Builder",
  "Gamification",
  "Exhibitor Management",
  "Booth & Lead Capture",
  "Floor Planner",
  "Polls / Live Q&A",
  "Meeting Planner",
  "Push Notification",
  "Engagement & Matchmaking",
  "Community & Social Network",
  "Abstract Management",
];

export const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const countryCodes = [
  "US +1",
  "CA +1",
  "AU +61",
  "GB +44",
  "AF +93",
  "AL +355",
  "DZ +213",
  "AD +376",
  "AO +244",
  "AR +54",
  "AM +374",
  "AT +43",
  "AZ +994",
  "BH +973",
  "BD +880",
  "BY +375",
  "BE +32",
  "BZ +501",
  "BJ +229",
  "BT +975",
  "BO +591",
  "BA +387",
  "BW +267",
  "BR +55",
  "BN +673",
  "BG +359",
  "BF +226",
  "BI +257",
  "KH +855",
  "CM +237",
  "CV +238",
  "CF +236",
  "TD +235",
  "CL +56",
  "CN +86",
  "CO +57",
  "KM +269",
  "CG +242",
  "CD +243",
  "CR +506",
  "HR +385",
  "CU +53",
  "CY +357",
  "CZ +420",
  "DK +45",
  "DJ +253",
  "DM +1-767",
  "DO +1-809",
  "TL +670",
  "EC +593",
  "EG +20",
  "SV +503",
  "GQ +240",
  "ER +291",
  "EE +372",
  "ET +251",
  "FJ +679",
  "FI +358",
  "FR +33",
  "GA +241",
  "GM +220",
  "GE +995",
  "DE +49",
  "GH +233",
  "GR +30",
  "GD +1-473",
  "GT +502",
  "GN +224",
  "GW +245",
  "GY +592",
  "HT +509",
  "HN +504",
  "HU +36",
  "IS +354",
  "IN +91",
  "ID +62",
  "IR +98",
  "IQ +964",
  "IE +353",
  "IL +972",
  "IT +39",
  "CI +225",
  "JM +1-876",
  "JP +81",
  "JO +962",
  "KZ +7",
  "KE +254",
  "KI +686",
  "KP +850",
  "KR +82",
  "XK +383",
  "KW +965",
  "KG +996",
  "LA +856",
  "LV +371",
  "LB +961",
  "LS +266",
  "LR +231",
  "LY +218",
  "LI +423",
  "LT +370",
  "LU +352",
  "MK +389",
  "MG +261",
  "MW +265",
  "MY +60",
  "MV +960",
  "ML +223",
  "MT +356",
  "MH +692",
  "MR +222",
  "MU +230",
  "MX +52",
  "FM +691",
  "MD +373",
  "MC +377",
  "MN +976",
  "ME +382",
  "MA +212",
  "MZ +258",
  "MM +95",
  "NA +264",
  "NR +674",
  "NP +977",
  "NL +31",
  "NZ +64",
  "NI +505",
  "NE +227",
  "NG +234",
  "NO +47",
  "OM +968",
  "PK +92",
  "PW +680",
  "PA +507",
  "PG +675",
  "PY +595",
  "PE +51",
  "PH +63",
  "PL +48",
  "PT +351",
  "QA +974",
  "RO +40",
  "RU +7",
  "RW +250",
  "KN +1-869",
  "LC +1-758",
  "VC +1-784",
  "WS +685",
  "SM +378",
  "ST +239",
  "SA +966",
  "SN +221",
  "RS +381",
  "SC +248",
  "SL +232",
  "SG +65",
  "SK +421",
  "SI +386",
  "SB +677",
  "SO +252",
  "ZA +27",
  "SS +211",
  "ES +34",
  "LK +94",
  "SD +249",
  "SR +597",
  "SZ +268",
  "SE +46",
  "CH +41",
  "SY +963",
  "TW +886",
  "TJ +992",
  "TZ +255",
  "TH +66",
  "TG +228",
  "TO +676",
  "TT +1-868",
  "TN +216",
  "TR +90",
  "TM +993",
  "TV +688",
  "UG +256",
  "UA +380",
  "AE +971",
  "UY +598",
  "UZ +998",
  "VU +678",
  "VA +379",
  "VE +58",
  "VN +84",
  "YE +967",
  "ZM +260",
  "ZW +263",
];

export const attendeeOptions = [
  "Select one...",
  "<400",
  "400-1000",
  "1K-5K",
  "5-25K",
  "25K-50K",
  "50K-100K",
  ">100K",
];

export const industries = [
  "Select one...",
  "Agriculture",
  "Automotive",
  "Accounting / Booking Keeping",
  "Banking",
  "Non Banking Finance",
  "Investment",
  "Biotechnology",
  "Construction",
  "Consumer Electronics",
  "Education",
  "Energy",
  "Entertainment",
  "Fashion",
  "Finance",
  "Food and Beverage",
  "Healthcare",
  "Hospitality",
  "Information Technology",
  "Insurance",
  "Legal Services",
  "Logistics",
  "Manufacturing",
  "Marketing and Advertising",
  "Media",
  "Mining",
  "Nonprofit",
  "Pharmaceuticals",
  "Professional Services",
  "Real Estate",
  "Retail",
  "Religion",
  "Telecommunications",
  "Tourism",
  "Transportation",
  "Utilities",
  "Venture Capital",
  "Waste Management",
  "Wholesale Trade",
  "Aerospace",
  "Chemicals",
  "Defense",
  "E-commerce",
  "Environmental Services",
  "Event Planning",
  "Human Resources & Recruitment",
  "Interior Design",
  "Market Research",
  "Personal Care",
  "Printing and Publishing",
  "Public Relations",
  "Security Services",
  "Sports Management",
  "Technology Hardware",
  "Video Games",
];

export const timeZoneMap = [
  // UTC-12:00
  { label: "Baker Island Time", zone: "Etc/GMT+12" },

  // UTC-11:00
  { label: "Samoa Standard Time", zone: "Pacific/Pago_Pago" },
  { label: "Niue Time", zone: "Pacific/Niue" },

  // UTC-10:00
  { label: "Hawaii Standard Time", zone: "Pacific/Honolulu" },
  { label: "Cook Islands Time", zone: "Pacific/Rarotonga" },
  { label: "Tahiti Time", zone: "Pacific/Tahiti" },
  { label: "Hawaii-Aleutian Standard Time", zone: "America/Adak" },

  // UTC-09:30
  { label: "Marquesas Time", zone: "Pacific/Marquesas" },

  // UTC-09:00
  { label: "Alaska Standard Time", zone: "America/Anchorage" },
  { label: "Gambier Time", zone: "Pacific/Gambier" },

  // UTC-08:00
  { label: "Pacific Standard Time", zone: "America/Los_Angeles" },
  { label: "Pacific Standard Time (Vancouver)", zone: "America/Vancouver" },
  { label: "Pacific Standard Time (Tijuana)", zone: "America/Tijuana" },
  { label: "Pitcairn Time", zone: "Pacific/Pitcairn" },

  // UTC-07:00
  { label: "Mountain Standard Time", zone: "America/Denver" },
  { label: "Mountain Standard Time (Phoenix)", zone: "America/Phoenix" },
  { label: "Mountain Standard Time (Edmonton)", zone: "America/Edmonton" },
  { label: "Pacific Daylight Time", zone: "America/Los_Angeles" },
  { label: "Mexican Pacific Time", zone: "America/Mazatlan" },

  // UTC-06:00
  { label: "Central Standard Time", zone: "America/Chicago" },
  { label: "Central Standard Time (Mexico City)", zone: "America/Mexico_City" },
  { label: "Central Standard Time (Winnipeg)", zone: "America/Winnipeg" },
  { label: "Central Standard Time (Guatemala)", zone: "America/Guatemala" },
  { label: "Mountain Daylight Time", zone: "America/Denver" },
  { label: "Galapagos Time", zone: "Pacific/Galapagos" },
  { label: "Easter Island Time", zone: "Pacific/Easter" },

  // UTC-05:00
  { label: "Eastern Standard Time", zone: "America/New_York" },
  { label: "Eastern Standard Time (Toronto)", zone: "America/Toronto" },
  { label: "Colombia Time", zone: "America/Bogota" },
  { label: "Ecuador Time", zone: "America/Guayaquil" },
  { label: "Peru Time", zone: "America/Lima" },
  { label: "Central Daylight Time", zone: "America/Chicago" },
  { label: "Cuba Standard Time", zone: "America/Havana" },
  { label: "Panama Time", zone: "America/Panama" },
  { label: "Jamaica Time", zone: "America/Jamaica" },
  { label: "Cayman Islands Time", zone: "America/Cayman" },

  // UTC-04:00
  { label: "Atlantic Standard Time", zone: "America/Halifax" },
  { label: "Venezuela Time", zone: "America/Caracas" },
  { label: "Bolivia Time", zone: "America/La_Paz" },
  { label: "Eastern Daylight Time", zone: "America/New_York" },
  { label: "Chile Time", zone: "America/Santiago" },
  { label: "Paraguay Time", zone: "America/Asuncion" },
  { label: "Atlantic Time (Barbados)", zone: "America/Barbados" },
  { label: "Atlantic Time (Puerto Rico)", zone: "America/Puerto_Rico" },
  { label: "Amazon Time (Manaus)", zone: "America/Manaus" },

  // UTC-03:30
  { label: "Newfoundland Standard Time", zone: "America/St_Johns" },

  // UTC-03:00
  { label: "Argentina Time", zone: "America/Argentina/Buenos_Aires" },
  { label: "Brazil Time (São Paulo)", zone: "America/Sao_Paulo" },
  { label: "Chile Summer Time", zone: "America/Santiago" },
  { label: "Uruguay Time", zone: "America/Montevideo" },
  { label: "Suriname Time", zone: "America/Paramaribo" },
  { label: "French Guiana Time", zone: "America/Cayenne" },
  { label: "Brasília Time", zone: "America/Sao_Paulo" },
  { label: "Atlantic Daylight Time", zone: "America/Halifax" },
  { label: "Greenland Standard Time", zone: "America/Godthab" },
  { label: "Falkland Islands Time", zone: "Atlantic/Stanley" },

  // UTC-02:00
  { label: "Fernando de Noronha Time", zone: "America/Noronha" },
  { label: "South Georgia Time", zone: "Atlantic/South_Georgia" },
  { label: "Mid-Atlantic Time", zone: "Etc/GMT+2" },

  // UTC-01:00
  { label: "Azores Time", zone: "Atlantic/Azores" },
  { label: "Cape Verde Time", zone: "Atlantic/Cape_Verde" },
  { label: "East Greenland Time", zone: "America/Scoresbysund" },

  // UTC+00:00
  { label: "Greenwich Mean Time", zone: "Europe/London" },
  { label: "Western European Time", zone: "Europe/Lisbon" },
  { label: "Coordinated Universal Time", zone: "Etc/UTC" },
  { label: "West Africa Time", zone: "Africa/Lagos" },
  { label: "Morocco Time", zone: "Africa/Casablanca" },
  { label: "Iceland Time", zone: "Atlantic/Reykjavik" },
  { label: "Ghana Time", zone: "Africa/Accra" },
  { label: "Senegal Time", zone: "Africa/Dakar" },
  { label: "Ivory Coast Time", zone: "Africa/Abidjan" },

  // UTC+01:00
  { label: "Central European Time", zone: "Europe/Paris" },
  { label: "Central European Time (Berlin)", zone: "Europe/Berlin" },
  { label: "Central European Time (Rome)", zone: "Europe/Rome" },
  { label: "Central European Time (Madrid)", zone: "Europe/Madrid" },
  { label: "Central European Time (Amsterdam)", zone: "Europe/Amsterdam" },
  { label: "Central European Time (Brussels)", zone: "Europe/Brussels" },
  { label: "Central European Time (Vienna)", zone: "Europe/Vienna" },
  { label: "Central European Time (Zurich)", zone: "Europe/Zurich" },
  { label: "Central European Time (Prague)", zone: "Europe/Prague" },
  { label: "Central European Time (Budapest)", zone: "Europe/Budapest" },
  { label: "Central European Time (Warsaw)", zone: "Europe/Warsaw" },
  { label: "British Summer Time", zone: "Europe/London" },
  { label: "West Africa Time (Lagos)", zone: "Africa/Lagos" },
  { label: "Central Africa Time (Kinshasa)", zone: "Africa/Kinshasa" },
  { label: "West Central Africa Time", zone: "Africa/Luanda" },
  { label: "Nigeria Time", zone: "Africa/Lagos" },
  { label: "Algeria Time", zone: "Africa/Algiers" },
  { label: "Tunisia Time", zone: "Africa/Tunis" },

  // UTC+02:00
  { label: "Eastern European Time", zone: "Europe/Kiev" },
  { label: "Central African Time", zone: "Africa/Harare" },
  { label: "South Africa Standard Time", zone: "Africa/Johannesburg" },
  { label: "Egypt Standard Time", zone: "Africa/Cairo" },
  { label: "Israel Standard Time", zone: "Asia/Jerusalem" },
  { label: "Eastern European Time (Helsinki)", zone: "Europe/Helsinki" },
  { label: "Eastern European Time (Athens)", zone: "Europe/Athens" },
  { label: "Eastern European Time (Bucharest)", zone: "Europe/Bucharest" },
  { label: "Eastern European Time (Sofia)", zone: "Europe/Sofia" },
  { label: "Central European Summer Time", zone: "Europe/Paris" },
  { label: "Libya Time", zone: "Africa/Tripoli" },
  { label: "Sudan Time", zone: "Africa/Khartoum" },
  { label: "Botswana Time", zone: "Africa/Gaborone" },
  { label: "Zambia Time", zone: "Africa/Lusaka" },
  { label: "Zimbabwe Time", zone: "Africa/Harare" },
  { label: "Malawi Time", zone: "Africa/Blantyre" },
  { label: "Mozambique Time", zone: "Africa/Maputo" },
  { label: "Swaziland Time", zone: "Africa/Mbabane" },
  { label: "Lesotho Time", zone: "Africa/Maseru" },

  // UTC+03:00
  { label: "Moscow Standard Time", zone: "Europe/Moscow" },
  { label: "East Africa Time", zone: "Africa/Nairobi" },
  { label: "Arabia Standard Time", zone: "Asia/Riyadh" },
  { label: "Turkey Time", zone: "Europe/Istanbul" },
  { label: "Baghdad Time", zone: "Asia/Baghdad" },
  { label: "Kuwait Time", zone: "Asia/Kuwait" },
  { label: "Qatar Time", zone: "Asia/Qatar" },
  { label: "Bahrain Time", zone: "Asia/Bahrain" },
  { label: "Eastern European Summer Time", zone: "Europe/Kiev" },
  { label: "Belarus Time", zone: "Europe/Minsk" },
  { label: "Kaliningrad Time", zone: "Europe/Kaliningrad" },
  { label: "Ethiopia Time", zone: "Africa/Addis_Ababa" },
  { label: "Kenya Time", zone: "Africa/Nairobi" },
  { label: "Tanzania Time", zone: "Africa/Dar_es_Salaam" },
  { label: "Uganda Time", zone: "Africa/Kampala" },
  { label: "Rwanda Time", zone: "Africa/Kigali" },
  { label: "Burundi Time", zone: "Africa/Bujumbura" },
  { label: "Somalia Time", zone: "Africa/Mogadishu" },
  { label: "Djibouti Time", zone: "Africa/Djibouti" },
  { label: "Eritrea Time", zone: "Africa/Asmara" },
  { label: "Comoros Time", zone: "Indian/Comoro" },
  { label: "Madagascar Time", zone: "Indian/Antananarivo" },
  { label: "Mayotte Time", zone: "Indian/Mayotte" },

  // UTC+03:30
  { label: "Iran Standard Time", zone: "Asia/Tehran" },

  // UTC+04:00
  { label: "Gulf Standard Time", zone: "Asia/Dubai" },
  { label: "Azerbaijan Time", zone: "Asia/Baku" },
  { label: "Armenia Time", zone: "Asia/Yerevan" },
  { label: "Georgia Time", zone: "Asia/Tbilisi" },
  { label: "Samara Time", zone: "Europe/Samara" },
  { label: "Mauritius Time", zone: "Indian/Mauritius" },
  { label: "Réunion Time", zone: "Indian/Reunion" },
  { label: "Seychelles Time", zone: "Indian/Mahe" },
  { label: "Oman Time", zone: "Asia/Muscat" },

  // UTC+04:30
  { label: "Afghanistan Time", zone: "Asia/Kabul" },

  // UTC+05:00
  { label: "Pakistan Standard Time", zone: "Asia/Karachi" },
  { label: "Uzbekistan Time", zone: "Asia/Tashkent" },
  { label: "Turkmenistan Time", zone: "Asia/Ashgabat" },
  { label: "Tajikistan Time", zone: "Asia/Dushanbe" },
  { label: "Kazakhstan Time (West)", zone: "Asia/Aqtobe" },
  { label: "Kyrgyzstan Time", zone: "Asia/Bishkek" },
  { label: "Yekaterinburg Time", zone: "Asia/Yekaterinburg" },
  { label: "Maldives Time", zone: "Indian/Maldives" },
  { label: "French Southern and Antarctic Time", zone: "Indian/Kerguelen" },

  // UTC+05:30
  { label: "India Standard Time", zone: "Asia/Kolkata" },
  { label: "Sri Lanka Time", zone: "Asia/Colombo" },

  // UTC+05:45
  { label: "Nepal Time", zone: "Asia/Kathmandu" },

  // UTC+06:00
  { label: "Bangladesh Time", zone: "Asia/Dhaka" },
  { label: "Bhutan Time", zone: "Asia/Thimphu" },
  { label: "Kazakhstan Time (East)", zone: "Asia/Almaty" },
  { label: "Kyrgyzstan Time", zone: "Asia/Bishkek" },
  { label: "Omsk Time", zone: "Asia/Omsk" },
  { label: "British Indian Ocean Time", zone: "Indian/Chagos" },

  // UTC+06:30
  { label: "Myanmar Time", zone: "Asia/Yangon" },
  { label: "Cocos Islands Time", zone: "Indian/Cocos" },

  // UTC+07:00
  { label: "Indochina Time", zone: "Asia/Bangkok" },
  { label: "Vietnam Time", zone: "Asia/Ho_Chi_Minh" },
  { label: "Cambodia Time", zone: "Asia/Phnom_Penh" },
  { label: "Laos Time", zone: "Asia/Vientiane" },
  { label: "Thailand Time", zone: "Asia/Bangkok" },
  { label: "Indonesia Western Time", zone: "Asia/Jakarta" },
  { label: "Krasnoyarsk Time", zone: "Asia/Krasnoyarsk" },
  { label: "Novosibirsk Time", zone: "Asia/Novosibirsk" },
  { label: "Christmas Island Time", zone: "Indian/Christmas" },

  // UTC+08:00
  { label: "China Standard Time", zone: "Asia/Shanghai" },
  { label: "Hong Kong Time", zone: "Asia/Hong_Kong" },
  { label: "Macau Time", zone: "Asia/Macau" },
  { label: "Taiwan Time", zone: "Asia/Taipei" },
  { label: "Singapore Time", zone: "Asia/Singapore" },
  { label: "Malaysia Time", zone: "Asia/Kuala_Lumpur" },
  { label: "Philippines Time", zone: "Asia/Manila" },
  { label: "Indonesia Central Time", zone: "Asia/Makassar" },
  { label: "Brunei Time", zone: "Asia/Brunei" },
  { label: "Mongolia Time", zone: "Asia/Ulaanbaatar" },
  { label: "Irkutsk Time", zone: "Asia/Irkutsk" },
  { label: "Australian Western Standard Time", zone: "Australia/Perth" },

  // UTC+08:45
  {
    label: "Australian Central Western Standard Time",
    zone: "Australia/Eucla",
  },

  // UTC+09:00
  { label: "Japan Standard Time", zone: "Asia/Tokyo" },
  { label: "Korea Standard Time", zone: "Asia/Seoul" },
  { label: "Indonesia Eastern Time", zone: "Asia/Jayapura" },
  { label: "East Timor Time", zone: "Asia/Dili" },
  { label: "Yakutsk Time", zone: "Asia/Yakutsk" },
  { label: "Palau Time", zone: "Pacific/Palau" },

  // UTC+09:30
  { label: "Australian Central Standard Time", zone: "Australia/Adelaide" },
  {
    label: "Australian Central Standard Time (Darwin)",
    zone: "Australia/Darwin",
  },

  // UTC+10:00
  { label: "Australian Eastern Standard Time", zone: "Australia/Sydney" },
  {
    label: "Australian Eastern Standard Time (Melbourne)",
    zone: "Australia/Melbourne",
  },
  {
    label: "Australian Eastern Standard Time (Brisbane)",
    zone: "Australia/Brisbane",
  },
  { label: "Papua New Guinea Time", zone: "Pacific/Port_Moresby" },
  { label: "Vladivostok Time", zone: "Asia/Vladivostok" },
  { label: "Chamorro Standard Time", zone: "Pacific/Guam" },
  { label: "Chuuk Time", zone: "Pacific/Chuuk" },

  // UTC+10:30
  { label: "Lord Howe Standard Time", zone: "Australia/Lord_Howe" },

  // UTC+11:00
  { label: "Solomon Islands Time", zone: "Pacific/Guadalcanal" },
  { label: "Vanuatu Time", zone: "Pacific/Efate" },
  { label: "New Caledonia Time", zone: "Pacific/Noumea" },
  { label: "Magadan Time", zone: "Asia/Magadan" },
  { label: "Sakhalin Time", zone: "Asia/Sakhalin" },
  { label: "Pohnpei Time", zone: "Pacific/Pohnpei" },
  { label: "Kosrae Time", zone: "Pacific/Kosrae" },
  { label: "Norfolk Island Time", zone: "Pacific/Norfolk" },

  // UTC+12:00
  { label: "Fiji Time", zone: "Pacific/Fiji" },
  { label: "Tuvalu Time", zone: "Pacific/Funafuti" },
  { label: "Gilbert Islands Time", zone: "Pacific/Tarawa" },
  { label: "Nauru Time", zone: "Pacific/Nauru" },
  { label: "Marshall Islands Time", zone: "Pacific/Majuro" },
  { label: "Wake Island Time", zone: "Pacific/Wake" },
  { label: "Wallis and Futuna Time", zone: "Pacific/Wallis" },
  { label: "Kamchatka Time", zone: "Asia/Kamchatka" },
  { label: "Anadyr Time", zone: "Asia/Anadyr" },
  { label: "New Zealand Standard Time", zone: "Pacific/Auckland" },

  // UTC+12:45
  { label: "Chatham Standard Time", zone: "Pacific/Chatham" },

  // UTC+13:00
  { label: "Tonga Time", zone: "Pacific/Tongatapu" },
  { label: "Phoenix Islands Time", zone: "Pacific/Enderbury" },
  { label: "Samoa Daylight Time", zone: "Pacific/Apia" },

  // UTC+14:00
  { label: "Line Islands Time", zone: "Pacific/Kiritimati" },
];

export const dayNames = ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"];

export const parseLocalDate = (dateStr) => {
  const [year, month, day] = dateStr.split("-").map(Number);
  return new Date(year, month - 1, day); // Local date
};

export const formatDateLocal = (date) => {
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

// Timezone aliases mapping
export const timezoneAliases = {
  // Your existing aliases
  "Asia/Calcutta": "Asia/Kolkata",
  "Asia/Kolkata": "Asia/Kolkata",
  "US/Eastern": "America/New_York",
  "US/Central": "America/Chicago",
  "US/Mountain": "America/Denver",
  "US/Pacific": "America/Los_Angeles",
  "Europe/Kiev": "Europe/Kyiv",

  // Additional US Legacy Aliases
  "US/Alaska": "America/Anchorage",
  "US/Arizona": "America/Phoenix",
  "US/Hawaii": "Pacific/Honolulu",
  "US/Indiana-Starke": "America/Indiana/Knox",
  "US/Michigan": "America/Detroit",
  "US/Samoa": "Pacific/Pago_Pago",

  // Canada Legacy Aliases
  "Canada/Atlantic": "America/Halifax",
  "Canada/Central": "America/Winnipeg",
  "Canada/Eastern": "America/Toronto",
  "Canada/Mountain": "America/Edmonton",
  "Canada/Newfoundland": "America/St_Johns",
  "Canada/Pacific": "America/Vancouver",
  "Canada/Saskatchewan": "America/Regina",
  "Canada/Yukon": "America/Whitehorse",

  // Europe Legacy Aliases
  "Europe/Belfast": "Europe/London",
  "Europe/Nicosia": "Asia/Nicosia",
  "Europe/Tiraspol": "Europe/Chisinau",
  "Europe/Uzhgorod": "Europe/Kyiv",
  "Europe/Zaporozhye": "Europe/Kyiv",

  // Asia Legacy and Alternative Names
  "Asia/Ashkhabad": "Asia/Ashgabat",
  "Asia/Dacca": "Asia/Dhaka",
  "Asia/Katmandu": "Asia/Kathmandu",
  "Asia/Macao": "Asia/Macau",
  "Asia/Saigon": "Asia/Ho_Chi_Minh",
  "Asia/Tel_Aviv": "Asia/Jerusalem",
  "Asia/Thimbu": "Asia/Thimphu",
  "Asia/Ujung_Pandang": "Asia/Makassar",
  "Asia/Ulan_Bator": "Asia/Ulaanbaatar",
  "Asia/Chongqing": "Asia/Shanghai",
  "Asia/Chungking": "Asia/Shanghai",
  "Asia/Harbin": "Asia/Shanghai",
  "Asia/Kashgar": "Asia/Urumqi",

  // Africa Legacy Aliases
  "Africa/Asmera": "Africa/Asmara",
  "Africa/Timbuktu": "Africa/Bamako",

  // Australia Legacy Aliases
  "Australia/ACT": "Australia/Sydney",
  "Australia/Canberra": "Australia/Sydney",
  "Australia/LHI": "Australia/Lord_Howe",
  "Australia/NSW": "Australia/Sydney",
  "Australia/North": "Australia/Darwin",
  "Australia/Queensland": "Australia/Brisbane",
  "Australia/South": "Australia/Adelaide",
  "Australia/Tasmania": "Australia/Hobart",
  "Australia/Victoria": "Australia/Melbourne",
  "Australia/West": "Australia/Perth",
  "Australia/Yancowinna": "Australia/Broken_Hill",

  // Pacific Legacy Aliases
  "Pacific/Johnston": "Pacific/Honolulu",
  "Pacific/Ponape": "Pacific/Pohnpei",
  "Pacific/Samoa": "Pacific/Pago_Pago",
  "Pacific/Truk": "Pacific/Chuuk",
  "Pacific/Yap": "Pacific/Chuuk",

  // America Legacy Aliases
  "America/Argentina/ComodRivadavia": "America/Argentina/Catamarca",
  "America/Atka": "America/Adak",
  "America/Buenos_Aires": "America/Argentina/Buenos_Aires",
  "America/Catamarca": "America/Argentina/Catamarca",
  "America/Coral_Harbour": "America/Atikokan",
  "America/Cordoba": "America/Argentina/Cordoba",
  "America/Ensenada": "America/Tijuana",
  "America/Fort_Wayne": "America/Indiana/Indianapolis",
  "America/Indianapolis": "America/Indiana/Indianapolis",
  "America/Jujuy": "America/Argentina/Jujuy",
  "America/Knox_IN": "America/Indiana/Knox",
  "America/Louisville": "America/Kentucky/Louisville",
  "America/Mendoza": "America/Argentina/Mendoza",
  "America/Montreal": "America/Toronto",
  "America/Porto_Acre": "America/Rio_Branco",
  "America/Rosario": "America/Argentina/Cordoba",
  "America/Santa_Isabel": "America/Tijuana",
  "America/Shiprock": "America/Denver",
  "America/Virgin": "America/Port_of_Spain",

  // Brazil Legacy Aliases
  "Brazil/Acre": "America/Rio_Branco",
  "Brazil/DeNoronha": "America/Noronha",
  "Brazil/East": "America/Sao_Paulo",
  "Brazil/West": "America/Manaus",

  // Chile Legacy Aliases
  "Chile/Continental": "America/Santiago",
  "Chile/EasterIsland": "Pacific/Easter",

  // Mexico Legacy Aliases
  "Mexico/BajaNorte": "America/Tijuana",
  "Mexico/BajaSur": "America/Mazatlan",
  "Mexico/General": "America/Mexico_City",

  // Argentina Legacy Aliases
  "Argentina/Buenos_Aires": "America/Argentina/Buenos_Aires",
  "Argentina/Catamarca": "America/Argentina/Catamarca",
  "Argentina/ComodRivadavia": "America/Argentina/Catamarca",
  "Argentina/Cordoba": "America/Argentina/Cordoba",
  "Argentina/Jujuy": "America/Argentina/Jujuy",
  "Argentina/La_Rioja": "America/Argentina/La_Rioja",
  "Argentina/Mendoza": "America/Argentina/Mendoza",
  "Argentina/Rio_Gallegos": "America/Argentina/Rio_Gallegos",
  "Argentina/Salta": "America/Argentina/Salta",
  "Argentina/San_Juan": "America/Argentina/San_Juan",
  "Argentina/San_Luis": "America/Argentina/San_Luis",
  "Argentina/Tucuman": "America/Argentina/Tucuman",
  "Argentina/Ushuaia": "America/Argentina/Ushuaia",

  // Common GMT/UTC Aliases
  GMT: "Etc/GMT",
  "GMT+0": "Etc/GMT",
  "GMT-0": "Etc/GMT",
  GMT0: "Etc/GMT",
  Greenwich: "Etc/GMT",
  UCT: "Etc/UTC",
  UTC: "Etc/UTC",
  Universal: "Etc/UTC",
  Zulu: "Etc/UTC",

  // Etc Legacy Aliases
  "Etc/GMT+0": "Etc/GMT",
  "Etc/GMT-0": "Etc/GMT",
  "Etc/GMT0": "Etc/GMT",
  "Etc/Greenwich": "Etc/GMT",
  "Etc/UCT": "Etc/UTC",
  "Etc/Universal": "Etc/UTC",
  "Etc/Zulu": "Etc/UTC",

  // POSIX Style Aliases
  EST: "Etc/GMT+5",
  MST: "Etc/GMT+7",
  HST: "Etc/GMT+10",

  // Windows Common Names (mapping to IANA)
  "Eastern Standard Time": "America/New_York",
  "Central Standard Time": "America/Chicago",
  "Mountain Standard Time": "America/Denver",
  "Pacific Standard Time": "America/Los_Angeles",
  "Alaskan Standard Time": "America/Anchorage",
  "Hawaiian Standard Time": "Pacific/Honolulu",
  "Atlantic Standard Time": "America/Halifax",

  // Self-referencing canonical names (ensuring consistency)
  "America/New_York": "America/New_York",
  "America/Chicago": "America/Chicago",
  "America/Denver": "America/Denver",
  "America/Los_Angeles": "America/Los_Angeles",
  "America/Anchorage": "America/Anchorage",
  "Pacific/Honolulu": "Pacific/Honolulu",
  "Europe/London": "Europe/London",
  "Europe/Paris": "Europe/Paris",
  "Europe/Berlin": "Europe/Berlin",
  "Europe/Rome": "Europe/Rome",
  "Europe/Madrid": "Europe/Madrid",
  "Europe/Amsterdam": "Europe/Amsterdam",
  "Europe/Brussels": "Europe/Brussels",
  "Europe/Vienna": "Europe/Vienna",
  "Europe/Zurich": "Europe/Zurich",
  "Europe/Moscow": "Europe/Moscow",
  "Asia/Tokyo": "Asia/Tokyo",
  "Asia/Shanghai": "Asia/Shanghai",
  "Asia/Seoul": "Asia/Seoul",
  "Asia/Singapore": "Asia/Singapore",
  "Asia/Dubai": "Asia/Dubai",
  "Australia/Sydney": "Australia/Sydney",
  "Australia/Melbourne": "Australia/Melbourne",
};
